import React from 'react';
import View from "./ViewItems/View";

const PricetariffsList = (props) => {
     const { dispatch, pricetariffs ,onRemovePricetariff, toggleValidFroms} = props;

     return (
         <>
             <div className="off-canvas-wrapper" style={{paddingTop:"25px"}}>
                 {pricetariffs.map((pricetariff,index) => {
                     return (
                     <View
                         dispatch={dispatch}
                         pricetariff={pricetariff}
                         onRemovePricetariff={onRemovePricetariff}
                         toggleValidFroms={toggleValidFroms}
                         index={index}
                         />
                     );
                 })}
             </div>
         </>
     )
}

export default PricetariffsList;